import { AvailableLanguages } from '../config/languages';
import i18next from 'i18next';
import { LocalStorageKey } from '../constants/localStorageKeys';
import { RegionTypes } from '../config/regions';

export class LanguageService {
	getCurrentLanguage = () => {
		return i18next.language || AvailableLanguages[0].lang;
	};

	getActiveLanguageObject = () => {
		return (
			AvailableLanguages.filter((resp) => resp.lang === i18next.language)[0] ||
			AvailableLanguages[0]
		);
	};

	getToggledLanguage = () => {
		return (
			AvailableLanguages.filter((resp) => resp.lang === this.toggleLanguage())[0] ||
			AvailableLanguages[0]
		);
	};

	toggleLanguage() {
		return i18next.language === 'en' ? 'ar' : 'en';
	}

	isArabic() {
		return this.getCurrentLanguage() === 'ar';
	}

	onToggleLanguage() {
		this.changeLanguage(this.toggleLanguage());
	}

	onBeforeLangChange() {
		localStorage.setItem(LocalStorageKey.investorsCollections, null);
		localStorage.setItem(LocalStorageKey.borrowersCollections, null);
	}

	changeLanguage = (lang) => {
		this.onBeforeLangChange();
		let pathArray = window.location.pathname.split('/');
		const queryParams = new URLSearchParams(window.location.search);
		let isAvailable = AvailableLanguages.find(
			(language) => language.lang === lang
		);
		if (isAvailable) {
			i18next.changeLanguage(lang);
			pathArray[1] = lang;
		} else {
			pathArray[1] = AvailableLanguages[0].lang;
			i18next.changeLanguage(AvailableLanguages[0].lang);
		}
		document.body.dir = i18next.dir(lang);
		let params = queryParams.toString() ? `?${queryParams.toString()}` : "";
		let newURL = pathArray.join('/');
		window.location.replace(`${newURL}${params}`);
	};

	handleWrongLanguage = () => {
		let pathArray = window.location.pathname.split('/');
		const isLegacyRegion = Object.values(RegionTypes).includes(pathArray[1]);
		if (isLegacyRegion) {
			pathArray.splice(1, 1);
			const hasLanguage = AvailableLanguages.some((language) => language.lang === pathArray[1]);
			if (!hasLanguage) {
				pathArray.splice(1, 0, AvailableLanguages[0].lang);
			}
			window.location.replace(`${pathArray.join('/')}${window.location.search}${window.location.hash}`);
			return;
		}
		let isAvailable = AvailableLanguages.find(
			(language) => language.lang === pathArray[1]
		);
		if (!isAvailable) {
			pathArray[1] = AvailableLanguages[0].lang;
			i18next.changeLanguage(AvailableLanguages[0].lang);
			document.body.dir = i18next.dir(AvailableLanguages[0].lang);
			let newURL = pathArray.join('/');
			window.location.replace(`${newURL}${window.location.search}${window.location.hash}`);
		}
		document.body.dir = i18next.dir(pathArray[1]);
	};
}
